import React from "react";
import CaseStudys from "../index";
import styles from "./styles.module.scss";
import devangibanner from "../../../assets/casestudy/devangibanner_1.webp";
import Devangi1stimg from "../../../assets/casestudy/Devangi1stimg.webp";
import devangi2ndimg from "../../../assets/casestudy/devangi2ndimg_1.webp";
import devangi3rdimg from "../../../assets/casestudy/devangi3rdimg.png";
import KumarPhotography from "../../../assets/img/KumarPhotoGraphy.png";
import Mongodbicon from "../../../assets/img/mongodbicon.svg";
import Nodeicon from "../../../assets/img/nodeicon.svg";
import Reacticon from "../../../assets/img/reacticon.svg";
import Expressicon from "../../../assets/img/expressicon.svg";
import genuiunimg from "../../../assets/casestudy/genuiunimg.png";
import Gnanodaya1stimg from "../../../assets/casestudy/gnanodaya1stimg.webp";

const DevangiAtithya = () => {
  const caseStudiesB = [
    {
      image: genuiunimg,
      title: "Genuine IT Systems",
      category: "Website Design",
      pagelink: "/devangiAtithya",
      link: "https://www.genitsgroup.com/",
    },
    {
      image: Gnanodaya1stimg,
      title: "Gnanodhaya VLSI Technologies",
      category: "Website Design",
      pagelink: "/gnanodhaya",
      link: "https://gnanodayavlsi.com/",
    },
  ];
  const servicesB = [
    { label: "UI & UX Design", link: "https://metasoft.ae/services" },
    { label: "Web Development", link: "https://metasoft.ae/services" },
    { label: "Performance Optimization", link: "https://metasoft.ae/services" },
    { label: "SEO", link: "https://metasoftdm.com/marketing-solutions/seo/" },
  ];
  return (
    <CaseStudys
      caseStudies={caseStudiesB}
      title="Devangi Atithya"
      subtitle="Experience Comfort and Warm Hospitality"
      header="Experience Comfort and Warm Hospitality"
      websiteUrl="https://devangiatithya.com/"
      industry="Resorts & Homestay"
      services={servicesB}
      description={
        <>
          <span> Devangi Atithya </span>Homestay is a tranquil getaway that
          blends traditional hospitality with modern amenities. To strengthen
          its online presence and streamline operations, we designed and
          developed a responsive website along with a custom admin panel. The
          platform allows guests to easily explore and book their stay, while
          providing the owners with efficient tools to manage bookings and daily
          operations.
        </>
      }
      objective={{
        heading: "Designing a Website That Highlights Comfort and Hospitality",
        content: (
          <>
            <p className={styles.projectText}>
              The objective of this project was to create a user-friendly
              digital platform that enhances the online presence and operational
              efficiency of Devangi Atithya Homestay. The goal was to design a
              responsive website that allows potential guests to easily access
              information, explore amenities, and make bookings, while also
              developing an admin panel to help the homestay manage
              reservations, availability, and guest communications. The project
              aimed to streamline both the guest experience and the day-to-day
              management process.
            </p>
          </>
        ),
      }}
      process={{
        heading: "How We Brought Devangi Atithya’s Homestay Online",
        content: (
          <>
            <p className={styles.projectText}>
              The project began with a thorough understanding of the homestay’s
              services, target audience, and operational needs. Based on this,
              we planned the site structure and features to ensure a smooth user
              journey for both guests and administrators. The design phase
              focused on creating a clean, welcoming interface that reflects the
              homestay’s peaceful vibe. Development was carried out in two
              parts: a responsive website for guests and a custom admin panel
              for managing bookings and availability. Regular feedback loops
              ensured the platform met both functional and aesthetic goals,
              followed by testing and final deployment.
            </p>
          </>
        ),
      }}
      impact={{
        heading: "The Positive Impact of the New Homestay Website",
        content: (
          <>
            <p className={styles.projectText}>
              The new digital platform significantly improved the homestay’s
              online visibility and guest engagement. The website made it easier
              for visitors to discover the property, explore amenities, and book
              their stay with confidence. The custom admin panel streamlined
              daily operations, reducing manual work and improving booking
              management. As a result, the homestay experienced better
              organization, faster response times, and an overall boost in
              customer satisfaction and operational efficiency.
            </p>
          </>
        ),
      }}
      conclusion={{
        heading: "Wrapping Up the Project",
        content: (
          <>
            <p className={styles.projectText}>
              In conclusion, the Devangi Atithya Homestay project successfully
              delivered a digital solution that enhanced both the guest
              experience and internal operations. By combining a user-friendly
              website with a practical admin panel, the project helped the
              homestay strengthen its online presence and manage bookings more
              efficiently. The result is a well-rounded platform that supports
              growth, improves customer satisfaction, and reflects the warmth
              and charm of the homestay itself.
            </p>
          </>
        ),
      }}
      heroImage={devangibanner} // Add the hero image
      projectImage={Devangi1stimg}
      projectImage2={devangi2ndimg}
      projectImage3={devangi3rdimg}
      // Add the project image
      technologies={[
        { name: "MongoDB", icon: Mongodbicon },
        { name: "Node.js", icon: Nodeicon },
        { name: "React", icon: Reacticon },
        { name: "Express.js", icon: Expressicon },
      ]} // Add the technologies used
      timescale="On-going" // Add the timescale
      launchDate="Soon" // Add the launch date
    />
  );
};

export default DevangiAtithya;
